import { render, staticRenderFns } from "./ArticlesContributions.vue?vue&type=template&id=0ce358d6&scoped=true&"
import script from "./ArticlesContributions.vue?vue&type=script&lang=js&"
export * from "./ArticlesContributions.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesContributions.vue?vue&type=style&index=0&id=0ce358d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce358d6",
  null
  
)

export default component.exports